import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var ChecklistSVG = function ChecklistSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M41.657,15.869a1.146,1.146,0,0,0,0-1.635L36.765,9.343A1.142,1.142,0,0,0,35.954,9a1.169,1.169,0,0,0-.823.343l-4.069,4.08,6.526,6.526Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M40.857,38.714H39.714a3.251,3.251,0,0,1-1.846-.6,11.325,11.325,0,0,0,1.992-6.2A5.779,5.779,0,0,0,39.1,28.83a3.33,3.33,0,0,0-5.621,0,5.779,5.779,0,0,0-.764,3.086,11.325,11.325,0,0,0,1.992,6.2,2.466,2.466,0,0,1-3.585-.408,4.768,4.768,0,0,1-.461-.751A6.309,6.309,0,0,0,31,35.036c0-1.5-.846-2.036-1.571-2.036s-1.572.533-1.572,2.036a6.321,6.321,0,0,0,.342,1.923,4.68,4.68,0,0,1-.46.75,2.188,2.188,0,0,1-1.739,1H18.812L35.954,21.583l-6.526-6.526L11.154,33.32a1.3,1.3,0,0,0-.16.194c-.023.057-.057.126-.092.2a.726.726,0,0,0-.08.262l-.811,5.715A1.161,1.161,0,0,0,11.134,41s0,0,.01,0H26a4.389,4.389,0,0,0,3.431-1.747A4.364,4.364,0,0,0,32.857,41a5.524,5.524,0,0,0,3.429-1.2A5.522,5.522,0,0,0,39.714,41h1.143a1.143,1.143,0,0,0,0-2.286Zm-4.571-2.342A9.069,9.069,0,0,1,35,31.916a3.611,3.611,0,0,1,.409-1.862,1.042,1.042,0,0,1,1.759,0,3.6,3.6,0,0,1,.41,1.862A9.069,9.069,0,0,1,36.286,36.372Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__foreground-color-fill",
    x: "17.643",
    y: "12.714",
    width: "7.286",
    height: "2.429",
    rx: "1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M28.571,5.429V34.571H4.286V5.429H28.571m0-2.429H4.286A2.428,2.428,0,0,0,1.857,5.429V34.571A2.428,2.428,0,0,0,4.286,37H28.571A2.428,2.428,0,0,0,31,34.571V5.429A2.428,2.428,0,0,0,28.571,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M14.889,10.024a1.072,1.072,0,0,0-1.577,0L10.62,12.887l-.788-.838a1.069,1.069,0,0,0-1.577,0,1.241,1.241,0,0,0,0,1.677L9.832,15.4a1.069,1.069,0,0,0,1.577,0l3.48-3.7A1.243,1.243,0,0,0,14.889,10.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M14.889,18.524a1.072,1.072,0,0,0-1.577,0L10.62,21.387l-.788-.838a1.069,1.069,0,0,0-1.577,0,1.241,1.241,0,0,0,0,1.677L9.832,23.9a1.069,1.069,0,0,0,1.577,0l3.48-3.7A1.243,1.243,0,0,0,14.889,18.524Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__foreground-color-fill",
    x: "17.643",
    y: "21.214",
    width: "7.286",
    height: "2.429",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__foreground-color-fill",
    x: "17.643",
    y: "28.5",
    width: "7.286",
    height: "2.429",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__foreground-color-fill",
    x: "9.143",
    y: "28.5",
    width: "4.857",
    height: "2.429",
    rx: "1"
  }));
};
ChecklistSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
ChecklistSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Checklist")
};
export default withDetailedIcon(ChecklistSVG);